import styled from 'styled-components';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Table from '@deprecated-ui/common/Table';
import color from '@deprecated-ui/_style/color';

interface IStyleContainerPageNavigation {
  paddingTop?: string;
  paddingBottom?: string;
}

const SContainerPageNavigation = styled.div < IStyleContainerPageNavigation >`
  position: relative;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;

  ${({ paddingTop }) =>
    paddingTop &&
    `
    padding-top: ${paddingTop};
    `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    `
    padding-bottom: ${paddingBottom};
    `}
`;

const SButtonPageNavigation = styled(Button).attrs({
  ml: '0px',
  mr: '0px',
  pl: '0px',
  pr: '0px',
  pt: '0px',
  pb: '0px',
  // @ts-expect-error
  type: 'borderless',
})`
  border-radius: 2px;
  color: ${color.midgray};
  font-size: 13px;
  font-family: ProximaNovaRg;
  padding: 0 5px;
  position: relative;
  display: block;
  right: 5px;
  line-height: 14.95px;
  margin-top: 4px;

  &:focus {
    color: ${color.midgray};
  }

  &:hover {
    background-color: ${color.primary};
    color: ${color.light};
  }
`;

const SContainerTable = styled.div`
  position: relative;
  display: block;
  padding: 0 20px;
`;

const Buttons = ['First', 'Previous', 'Next', 'Last'];

const STable = styled(Table)`
  padding-top: 20px;
  table {
    display: block;
    overflow-x: auto;
  }
  
  .ant-table-thead {
    tr {
      th {
        height: 40px;
      }
      .custom-column {
        border-bottom: 2px solid ${color.darkGray};
        padding: 0 20px 8px 10px;
        font-family: var(--regular-font);
        vertical-align: top;
        font-size: 14px;
        line-height: 16.1px;

        .ant-table-column-sorters {
          padding: 0;
        }

        .ant-table-column-sorter-full {
          bottom: 6px;
          right: 0;
        }

        .ant-table-column-sorter-inner {
          position: relative;
          top: 6px;
        }

        &:nth-child(1) {
          padding-left: 0px;
        }

        &:last-child {
          display: none;
        }
      }
    }
  }

  .ant-table-tbody {
    .custom-column {
      &:nth-child(1) {
        padding-left: 0px;
      }
    }

    tr {
      td {
        padding: 5px 10px;
        font-family: var(--regular-font);
        background: ${color.light};
        line-height: 16.1px;
        white-space: nowrap;

        :last-child {
          display: none;
        }
      }

      .cell-symbol-title {
        a:hover {
          color: unset;
        }
      }

      .coloring {
        color: ${color.primary};
      }
      .coloring[data-raw^="-" i] {
        color: ${color.sunsetOrange};
      }
    }
  }

  && .custom-column:hover {
    .delete-column-icon {
      display: block;
      color: red;
      font-weight: 700;
      cursor: pointer;
    }
  }
`;

const SDeleteIcon = styled.span`
  position: absolute;
  top: 0px;
  right: 1px;
  font-weight: bold;
  color: red;
  z-index: 10;
  cursor: pointer;
`;

const CustomColumn = styled.div`
  .delete-column-icon {
    display: none;
  }
`;

const SContainerNote = styled(Text).attrs({
  size: '14px',
})`
  position: relative;
  display: block;
  padding: 20px 15px 15px 15px;
`;

const FlagNew = styled(Flex).attrs({
  justify: 'center',
  align: 'center',
})`
  padding: 1.75px 4px;
  border: 1px solid #00AB6B;
  border-radius: 2px;
`;

export {
  SContainerNote,
  CustomColumn,
  SDeleteIcon,
  STable,
  Buttons,
  SContainerTable,
  SButtonPageNavigation,
  SContainerPageNavigation,
  Text,
  FlagNew,
};
